import React, { FC, useState } from "react";
import { View, Modal } from "react-native";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import BackgroundImage from "./sign-up-common-components/BackGroundImage";
import LoginForm from "./login-modal-components/LoginForm";
import { AppScreens } from "../../Utility/AppScreens";
import LoginModalContainer from "./login-modal-components/LoginModalContainer";
import { urls, dynamicWebUrl } from "../../../Api/configs";

interface LoginScreenModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  setModalType: (type: string) => void;
  path: string;
}

const LoginScreenModal: FC<LoginScreenModalProps> = ({
  showModal,
  setShowModal,
  setModalType,
  path,
}) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [showLoader, setShowLoader] = useState(false);

  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const onCloseClick = () => {
    setShowModal(false);
  };

  const onLoginSuccess = () => {
    if (path) {
      window.location.href = `${dynamicWebUrl}${path}`;
      setShowModal(false);
    } else {
      navigateToScreen(navigation, AppScreens.DrawerRoute, {
          username: username,
        });
      setShowModal(false);
    }
  };

  return (
    <View>
      <Modal
        animationType="fade"
        transparent={true}
        visible={showModal}
        onRequestClose={onCloseClick}
      >
        <LoginModalContainer>
          {/* <BackgroundImage deviceSize={deviceSize} styles={styles} /> */}
          <LoginForm
            styles={styles}
            username={username}
            setUserName={setUserName}
            password={password}
            setPassword={setPassword}
            onCloseClick={onCloseClick}
            navigation={navigation}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
            onLoginSuccess={onLoginSuccess}
            deviceSize={deviceSize}
            setModalType={setModalType}
          />
        </LoginModalContainer>
      </Modal>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "50%",
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 30,
      marginHorizontal: 40,
      marginVertical: 50,
      alignSelf: "center",
      borderRadius: 12,
    },
    inputStyle: {
      backgroundColor: AppColors.appBlueColor_3A5175,
      marginBottom: 10,
    },
    bgImageWidth: {
      width: "40%",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "65%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
      },
      inputStyle: {
        backgroundColor: AppColors.appBlueColor_3A5175,
        marginBottom: 10,
      },
      bgImageWidth: {
        width: "45%",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "70%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
      },
      inputStyle: {
        backgroundColor: AppColors.appBlueColor_3A5175,
        marginBottom: 10,
      },
      bgImageWidth: {
        width: "60%",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
      },
      inputStyle: {
        backgroundColor: AppColors.appBlueColor_3A5175,
        marginBottom: 10,
      },
      bgImageWidth: {
        width: "80%",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
      },
      inputStyle: {
        backgroundColor: AppColors.appBlueColor_3A5175,
        marginBottom: 10,
      },
      bgImageWidth: {
        width: "95%",
      },
    },
  }
);

export default LoginScreenModal;
